import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";
import bgImage from "../../assets/trucks-bg.png";
import AboutHero from "./AboutHero";


const Home = () => {
  const [awbInput, setAwbInput] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    let value = e.target.value.replace(/[ ,]+/g, "\n");
    setAwbInput(value);
  };

  const handleTrack = () => {
    if (!awbInput.trim()) return alert("Enter Tracking Number");

    const awbArray = awbInput
      .split(/\n+/)
      .map((awb) => awb.trim())
      .filter(Boolean);

    navigate("/tracking-box", { state: { awbArray } });
  };

  return (
    <>
      <section className="hero">
        <div className="bg" style={{ backgroundImage: `url(${bgImage})` }}></div>
        <div className="overlay"></div>

        <div className="content">
          <h1>
            Digital Innovation <br />
            For Hassle-Free <br />
            Logistics.
          </h1>

          <div className="tracking-box">
            <h3>Track Shipment</h3>
            <input
              type="text"
              placeholder="Enter AWB number"
              value={awbInput}
              onChange={handleChange}
            />
            <button onClick={handleTrack}>Track</button>
          </div>
        </div>
      </section>

      <AboutHero />
    </>
  );
};

export default Home;
